import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";

const DiscrepancyApproval = ({ seletedBranchCode }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "applicationid", label: "Application ID" },
    { id: "created", label: "Created By" },
    { id: "formNumber", label: "Application Number" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "customerName", label: "Customer Name" },
    { id: "type", label: "Application Type" },
  ]);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [toDate, setToDate] = useState(new Date());
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress,
    refetch: refetchApplicantData,
  } = useApplicantStatusData({
    status: "COLL_DISCREP",
    fromDate,
    toDate,
    authToken,
    useMakerEndpoint: false,
  });

  useEffect(() => {
    const intervalCall = setInterval(() => {
      refetchApplicantData();
    }, 60000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, [refetchApplicantData]);

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row = {
          applicationid: ForApprovalApplication.loanApplicationId,
          created: ForApprovalApplication.createdBy,
          formNumber: ForApprovalApplication.loanApplicationNumber,
          accountNumber: ForApprovalApplication.loanAccountNumber,
          customerid: ForApprovalApplication.customerId,
          customerName: ForApprovalApplication.customerName,
          mobile: ForApprovalApplication.mobileNumber?.trim(),
          type: `${removeUnderscores(ForApprovalApplication?.applicationType)} / ${removeUnderscores(ForApprovalApplication?.applicationSubType)}`,
          totalCollateralValue: ForApprovalApplication?.totalCollateralValue,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const GetAction = (loanApplicationId, loanApplicationNumber) => {
    return (
      <>
        <Button
          aria-label="Edit Branch"
          onClick={() =>
            onClickUpdateData(loanApplicationId, loanApplicationNumber)
          }
        >
          Proceed
        </Button>
      </>
    );
  };
  const onClickUpdateData = async (
    loanApplicationId,
    loanApplicationNumber,
    loanAccountNo,
    totalCollateralValue
  ) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
       const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
    const navigationData = {
      loanApplicationId,
      loanAccountNo,
      status: "DISCREPANCY",
      subStatus: result?.data?.applicationSubType || "",
      prePledgeLoan: prepledgeLoanAccountNumber || "",
      editable: false,
      loanType: result?.data?.applicationType || "",
      totalCollateralValue,
      seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.discrepancyApproval}
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="discrepancy"
        />
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

DiscrepancyApproval.propTypes = {
  classes: PropTypes.object,
};

export default DiscrepancyApproval;
